import React, { ComponentProps } from 'react';
import { Col, Row } from 'antd';
import { Button } from '@app/components/common/buttons/Button/Button';
import { useTranslation } from 'react-i18next';

interface BaseButtonsGroupProps extends ComponentProps<typeof Button> {
  className?: string;
  onCancel: () => void;
  loading?: boolean;
  size?: 'small' | 'middle' | 'large';
}

export const BaseButtonsGroup: React.FC<BaseButtonsGroupProps> = ({
  className,
  onCancel,
  loading,
  size = 'middle',
  ...props
}) => {
  const { t } = useTranslation();
  const isCompact = size === 'small';

  return (
    <Row
      className={className}
      gutter={[10, 10]}
      wrap={false}
      align="middle"
      justify={isCompact ? 'center' : 'start'}
      style={{ marginTop: 24 }}
    >
      <Col {...(isCompact ? { flex: '0 0 auto' } : { span: 12 })}>
        <Button
          type="ghost"
          onClick={onCancel}
          size={size}
          block={!isCompact}
          style={isCompact ? { minWidth: 80 } : undefined}
          {...props}
        >
          {t('common.cancel')}
        </Button>
      </Col>
      <Col {...(isCompact ? { flex: '0 0 auto' } : { span: 12 })}>
        <Button
          type="primary"
          loading={loading}
          htmlType="submit"
          size={size}
          block={!isCompact}
          style={isCompact ? { minWidth: 80 } : undefined}
          {...props}
        >
          {t('common.save')}
        </Button>
      </Col>
    </Row>
  );
};
